import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * FlagSelected Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?type=design&node-id=769-26346&mode=dev)
 * */
const FlagSelectedIcon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M.844 11.703V1.391m0 7.772 1.445-.445a4.405 4.405 0 0 1 3.605.459 4.407 4.407 0 0 0 3.52.487l1.368-.392a.516.516 0 0 0 .374-.496V3.401a.515.515 0 0 0-.657-.496l-1.086.31a4.407 4.407 0 0 1-3.52-.483 4.405 4.405 0 0 0-3.604-.459l-1.445.444" />;
    t1 = <path fill="currentColor" d="M.844 11.703V1.391m0 7.772 1.445-.445a4.405 4.405 0 0 1 3.605.459 4.407 4.407 0 0 0 3.52.487l1.368-.392a.516.516 0 0 0 .374-.496V3.401a.515.515 0 0 0-.657-.496l-1.086.31a4.407 4.407 0 0 1-3.52-.483 4.405 4.405 0 0 0-3.604-.459l-1.445.444" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default FlagSelectedIcon;